import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Database, Globe, Network, Wifi, Radio } from 'lucide-react';

const tabs = [

  {
    name: 'Domains',
    path: '/domains',
    icon: Globe,
  },
  {
    name: 'Subdomains',
    path: '/subdomains',
    icon: Network,
  },
  {
    name: 'IP Addresses',
    path: '/ip-addresses',
    icon: Wifi,
  },
  {
    name: 'Ports',
    path: '/ports',
    icon: Radio,
  },
];

export const AssetTabs = () => {
  const location = useLocation();

  return (
    <div className="border-b border-gray-800">
      <nav className="flex space-x-4 px-6" aria-label="Tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;
          
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex items-center space-x-2 py-4 px-3 text-sm font-medium border-b-2 ${
                isActive
                  ? 'border-blue-500 text-blue-500'
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700'
              }`}
            >
              <Icon className="h-4 w-4" />
              <span>{tab.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}